import { render } from "./heading-copy.vue?vue&type=template&id=362ba476"
import script from "./heading-copy.vue?vue&type=script&lang=js"
export * from "./heading-copy.vue?vue&type=script&lang=js"

import "./heading-copy.vue?vue&type=style&index=0&id=362ba476&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__